import React, { Component } from 'react';
import { Route, NavLink, Switch, Redirect } from 'react-router-dom';

class TermsOfUse extends Component {
    state = {
        loadedPost: null
    }

    componentDidMount () {

    }

    componentDidUpdate() {

    }
    // b, strong {
    //     font-weight: bolder;
    // }
    render () {
          const hTag = { textAlign: 'center',   marginTop: '30px'};
          const parentDiv = {  marginLeft: '500px',width:'900px',
          fontSize: '1.25em',
    lineHeight: '140%',
    fontWeight: 'bold',
    fontStyle: 'italic' };

    const divData = {  marginLeft: '500px',width:'900px',
  };
    const heading = {
    fontSize: '1.25em',
lineHeight: '140%',
fontWeight: 'bolder' };
const data = { textAlign: 'center'
 };

 const h2Heading = {
    fontSize: '1.75em',
    color: '#047A9C',
    fontWeight: '100',
    marginTop: '40px'
 }
        return (
        <div>
            <NavLink
                                to="/login/"
                                activeStyle={{
                                    color: '#fa923f',
                                    textDecoration: 'underline'
                                }}>back</NavLink>
<h1  style={hTag}><strong>Pearson End User License Agreement</strong></h1>
<br/>
<br/>
           <div style={parentDiv}>Please read the following carefully
<br/>
<br/>
 By clicking "I accept" or "I agree" or using the services you are entering into a binding contract with Pearson Education, Inc. and its affiliates. (collectively, "Pearson")
  
  
  </div>
  <br/>
<br/> <div  style={divData}> 
            <span style={heading}>IMPORTANT:</span>
         If you are a minor (a minor often is someone under the age of 18), you may not register for, or otherwise access, the Services (as defined below), nor may you consent to the terms of this End User License Agreement ("EULA" which includes the Privacy Statement) unless your educational institution or parent consents to and accepts the terms of this EULA on your behalf.
         <p>Privacy Statement) unless your educational institution or parent consents to and accepts the terms of this EULA on your behalf.

Children under the age of 13 may not accept the terms of this EULA, register for, or otherwise access, the Services unless an educational institution or parent has established an account or registered on their behalf.

If you have any questions about this EULA, please contact us at:<a target="_blank" href="https://support.pearson.com/getsupport/">https://support.pearson.com/getsupport/</a>

If you are a resident of New Jersey or access the Services from the State of New Jersey, please refer to Section 28, which addresses our obligations under the New Jersey Truth in Consumer Contract Warranty and Notice Act.

It is important to us that the Services provide you with a helpful and reliable experience. To protect our rights and yours, this EULA governs all uses of the Services. Access or use of the Services for which you seek registration or enrollment constitutes acceptance of this EULA as a binding agreement. By using the Services, you represent that you (1) have read and understood the terms, (2) agree to use the Services in compliance with applicable laws and the terms of this EULA and (3) are an Authorized User (as defined below). You may not use the Services if you do not agree with the EULA or if you are not an Authorized User.</p>
        
        <div style={h2Heading}> Privacy Statement</div>
        <p>
        Please review our Privacy Statement, which also governs your use of the Services, to understand our data collection and use practices. You acknowledge and explicitly consent to the collection and use of your data, including Personal Information (as defined in the Privacy Statement), in accordance with the Privacy Statement. Further, you acknowledge that the Privacy Statement may be revised from time to time for any reason.
        </p>
        
        <div style={h2Heading}>Changes to this EULA</div>
        <p>
        Pearson may make changes to this EULA from time to time for any reason. Typically, these changes are made to conform to current practices, comply with changing regulatory requirements, or other similar purposes. If Pearson modifies this EULA in a manner that materially changes the terms or scope of the Services made available to you, we will make reasonable efforts to notify you by either contacting you via email or posting reasonable notice in connection with the Services to alert you to such changes. Your continued use of the Services after reasonable notice of such changes to the EULA has been provided will constitute your consent to the revised EULA terms. If you have any questions about this EULA, please contact us
        </p>
        <div style={h2Heading}>The Services</div>
        <p>
        This website and its related applications and services (collectively the "Services") is owned by Pearson Education, Inc. and/or its affiliated companies (collectively, "we," "us," or "Pearson"). The Services may be delivered to you through the Internet via your browser or app (mobile or otherwise) and may include enrollment ("Enrollment") in one or more online courses ("Course(s)") provided through the Services for use in connection with classes and programs offered by your school, employer, university or other educational institution ("Institution"). While your User Account (defined below) for the Services may continue for an indefinite period of time during which you may enroll in other Courses, your access to those specific Courses provided through the Services is provided on a subscription basis for a limited period of time (each a "Subscription"). The Services may be provided directly by Pearson or accessed through a third party integration with accounts managed by your Institution or an integrated third party service provider ("Third Party Service"). The Services may link to or provide options to access third party websites or applications.
        </p>
         </div> 
        </div>
        )
    }
}

export default TermsOfUse;


// WEBPACK FOOTER //
// ./src/components/footer/termsOfUse.js